//@ts-check
import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
/**
 * @param {import('./types').ToolBarTabs & import('@material-ui/core').WithStyles} props
 */

var ToolBarTabs = function ToolBarTabs(_ref) {
  var classes = _ref.classes,
      value = _ref.value,
      onChange = _ref.onChange,
      tabs = _ref.tabs;

  var onChangeIdx = function onChangeIdx(e, newValue) {
    return onChange(e, tabs[newValue].value);
  };

  var valueIdx = false;
  var tab = tabs.find(function (t) {
    return t.value === value;
  });
  if (tab) valueIdx = tabs.indexOf(tab);
  return React.createElement(Tabs, {
    value: valueIdx,
    onChange: onChangeIdx,
    centered: true,
    TabIndicatorProps: {
      className: classes.tabIndicator
    }
  }, tabs.map(function (tab) {
    return React.createElement(Tab, {
      key: tab.value,
      label: tab.label,
      classes: {
        root: classes.tab,
        selected: classes.selectedTab
      }
    });
  }));
};

ToolBarTabs.defaultProps = {
  tabs: []
};
export default ToolBarTabs;